import { TFunction } from 'i18next'

import {
  VisitorParkingApiPricingEntry,
  VisitorParkingPricingEntry,
} from '@/models/features/visitor-parking.models'
import { transformCentsToDollars, transformDollarsToCents } from '@/utils'

export const getHoursLabel = (duration: number, t: TFunction<['parking-management']>) => {
  return t('parking-management:serviceFeeModal.hoursLabel', { count: duration })
}

export const getDefaultPricing = (): VisitorParkingPricingEntry[] =>
  Array.from({ length: 24 }, (_, index) => ({
    duration: index + 1,
    enabled: true,
    price: '',
  }))

export const composePricingFormValues = (
  apiPricing: VisitorParkingApiPricingEntry[],
): VisitorParkingPricingEntry[] => {
  const defaultPricing = getDefaultPricing()

  return defaultPricing.map((defaultEntry) => {
    const apiEntry = apiPricing.find((entry) => entry.duration === defaultEntry.duration)

    if (!apiEntry) {
      return defaultEntry
    }

    return {
      duration: apiEntry.duration,
      enabled: apiEntry.enabled,
      price: transformCentsToDollars(apiEntry.price).toString(),
    }
  })
}

export const composeApiPricing = (
  formPricing: VisitorParkingPricingEntry[],
): VisitorParkingApiPricingEntry[] =>
  formPricing.map((entry) => ({
    duration: entry.duration,
    enabled: entry.enabled,
    price: transformDollarsToCents(entry.price),
  }))
